<template>
	<img class="v-image" :style="{borderRadius}" :width="width" :height="height" @error="error()" :key="Date.now()" @click="preview"/>
</template>

<script>
const locks = [];
export default {
  props: {
    src: {
      default: ""
    },
    origin: {
      default: ""
    },
    def: {
      default: ""
    },
    width: {
      default: null
    },
    height: {
      default: null
    },
    radius: {
      default: null
    },
    type: {
      default: "png"
    },
    crop: {
      default: null
    },
    rotate: {
      default: 0,
      validator(value) {
        return -360 <= value && value <= 360;
      }
    },
    orient: {
      default: 0,
      validator(value) {
        let v = value % 360;
        return [0, 1, 2, 3].includes(value);
      }
    }
  },
  computed: {
    borderRadius() {
      return String.unit(this.radius, "px");
    },
    url: {
      get() {
        return this.$el.src;
      },
      set(value) {
        this.$el.src = value;
      }
    }
  },
  watch: {
    ["src"](value) {
      this.setSrc(value);
    }
  },
  methods: {
    setSrc(src) {
      let { origin, pathname, search } = URL.parse(src),
        url = `${pathname}${search}`;
      if (url) {
        src = URL.path(
          (isFunction(this.origin) ? this.origin(url) : this.origin) || origin,
          url
        );
        if (this.crop || this.rotate || this.orient) {
          let img = Object.assign(new Image(), {
            src,
            crossOrigin: "Anonymous",
            onload: () => {
              locks.remove(src);
              let { naturalWidth, naturalHeight } = img,
                context = Element.create("canvas", {
                  width: [0, 2].includes(this.orient)
                    ? naturalWidth
                    : naturalHeight,
                  height: [1, 3].includes(this.orient)
                    ? naturalWidth
                    : naturalHeight
                }).getContext("2d");
              context.rotateOrient(this.orient);
              context.rotateAngle(this.rotate);
              context.drawImage(img, 0, 0, naturalWidth, naturalHeight);
              this.url = URL.createObjectURL(
                URL.toFile(context.canvas.toDataURL(`image/${this.type}`))
              );
            },
            error: () => this.error()
          });
        } else {
          this.url = src;
        }
      } else {
        this.error();
      }
    },
    error() {
      if (!locks.includes(this.url)) {
        this.setSrc(this.def || "");
      }
    },
    preview() {
      if (
        "preview" in this.$attrs &&
        (this.$attrs.preview == "" || this.$attrs.preview)
      ) {
        this.$preview(this.$el.src);
      }
    }
  },
  mounted() {
    this.$el.ons(this.$listeners);
    this.setSrc(this.src);
  },
  destroyed() {
    /^blob:/.test(this.url) && URL.revokeObjectURL(this.url);
  }
};
</script>

<style lang="less">
.v-image {
  &[border] {
    border: 1px solid #cccccc;
  }
}
</style>
